import { render, staticRenderFns } from "./login-pwd.vue?vue&type=template&id=71da997c&scoped=true&"
import script from "./login-pwd.vue?vue&type=script&lang=js&"
export * from "./login-pwd.vue?vue&type=script&lang=js&"
import style0 from "./login-pwd.vue?vue&type=style&index=0&id=71da997c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71da997c",
  null
  
)

export default component.exports